import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { MouseEvent, useMemo, useState } from 'react';
import { useI18n } from '../../shared/i18n';
import { SettingsIcon } from './icons';

enum ThemeModeOption {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

export function ThemeModeControl() {
  const { t } = useI18n();
  const { mode, setMode } = useColorScheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const menuOpen = Boolean(anchorEl);

  const resolvedMode = mode ?? ThemeModeOption.System;
  const currentModeLabel = useMemo(() => {
    switch (resolvedMode) {
      case ThemeModeOption.Light:
        return t('app.theme.light');
      case ThemeModeOption.Dark:
        return t('app.theme.dark');
      default:
        return t('app.theme.system');
    }
  }, [resolvedMode, t]);

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleModeSelect = (nextMode: ThemeModeOption) => {
    setMode(nextMode);
    handleMenuClose();
  };

  return (
    <>
      <Tooltip title={`${t('app.theme.button')}: ${currentModeLabel}`}>
        <IconButton
          color="inherit"
          onClick={handleMenuOpen}
          aria-label={t('app.theme.button')}
          aria-haspopup="menu"
          aria-expanded={menuOpen ? 'true' : undefined}
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          disabled
        >{`${t('app.theme.button')}: ${currentModeLabel}`}</MenuItem>
        <MenuItem
          selected={resolvedMode === ThemeModeOption.Light}
          onClick={() => handleModeSelect(ThemeModeOption.Light)}
        >
          {t('app.theme.light')}
        </MenuItem>
        <MenuItem
          selected={resolvedMode === ThemeModeOption.Dark}
          onClick={() => handleModeSelect(ThemeModeOption.Dark)}
        >
          {t('app.theme.dark')}
        </MenuItem>
        <MenuItem
          selected={resolvedMode === ThemeModeOption.System}
          onClick={() => handleModeSelect(ThemeModeOption.System)}
        >
          {t('app.theme.system')}
        </MenuItem>
      </Menu>
    </>
  );
}
